import { createSlice } from "@reduxjs/toolkit";
import { getStudents,  addNewStudent,updateStudent,  deleteStudent, importStudent } from './thunk';

export const initialState = {
    students: [],
    error: {},
};

const StudentSlice = createSlice({
    name: 'StudentSlice',
    initialState,
    reducer: {},
    extraReducers: (builder) => {


        builder.addCase(getStudents.fulfilled, (state, action) => {
            if(action.payload && action.payload.success) {
       
            state.students = action.payload.data['data'];
            state.isStudentCreated = false;
            state.isStudentSuccess = true;
            }else {
                state.error = action.payload.data || null;
                state.isStudentSuccess = false;
            }
        });

        builder.addCase(getStudents.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.isStudentCreated = false;
            state.isStudentSuccess = false;
        });

        builder.addCase(addNewStudent.fulfilled, (state, action) => {
            if(action.payload && action.payload.success) {
                state.students.push(action.payload.data);
                state.isStudentCreated = true;
            }else {
                state.error = action.payload.data || null;
                state.isStudentCreated = false;
            }
        });

        builder.addCase(addNewStudent.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.isStudentCreated = false;
        });
 
        builder.addCase(updateStudent.fulfilled, (state, action) => {
            if(action.payload.success) {
                state.students = state.students.map(student =>
                    student.id === action.payload.data.id
                        ? {...student, ...action.payload.data}
                        : student
                );
                state.isStudentCreated = true;
                state.isSaveLoading = false;
            } else {
            state.error = action.payload.data || null;
            state.isStudentCreated = false;
            state.isSaveLoading = true;
             }

        });
        builder.addCase(updateStudent.rejected, (state, action) => {
            state.error = action.payload.error || null;
        });


        builder.addCase(deleteStudent.fulfilled, (state, action) => {
            console.log('delete student', action.payload);
            if(action.payload.success) {
                
            state.students = state.students.filter(
                student => student.id.toString() !== action.payload.student.toString()
            );
        }else{
            state.error = action.payload.data || null;
        }
        });

        builder.addCase(deleteStudent.rejected, (state, action) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(importStudent.fulfilled, (state, action) => {
            if(action.payload && action.payload.success) {
                state.isStudentCreated = true;
            }else {
                state.error = action.payload.data || null;
                state.isStudentCreated = false;
            }
        });

        builder.addCase(importStudent.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.isStudentCreated = false;
        });

    }
});

export default StudentSlice.reducer;